import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-search="container"]',
        input: '[js-search="input"]',
        item: '[js-search="item"]',
        featuredItem: '[js-search="featured-item"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(nodeSelectors.input).on('input', function () {
            let searchValue = $(this).val().toLowerCase()

            if( searchValue.length > 1 ) {
                $(nodeSelectors.featuredItem).hide()

                $(nodeSelectors.item).each(function () {
                    let title = $(this).data('title')

                    if( title.toLowerCase().includes(searchValue) ) {
                        $(this).show()
                    } else {
                        $(this).hide()
                    }
                })
            } else {
                $(nodeSelectors.featuredItem).show()
                $(nodeSelectors.item).show()
            }
        })
    }

    return Object.freeze({
        init,
        nodeSelectors,
    })
}